//import React, { useEffect, useState } from 'react';
import React, { history, useEffect, useState, useMemo } from "react";
import { useNavigate, useParams, useLocation, useHistory } from "react-router-dom";
import $, { parseJSON } from 'jquery';
import { useKeycloak } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import services from "../../services/services";
import { ReactKeycloakProvider } from '@react-keycloak/web';
//import { useNavigate } from 'react-router-dom';
import jwt from 'jwt-decode' // import dependency
const HeaderHTO = () => {
    const navigate = useNavigate();
    const companyIdChkLogin = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
    const studentIdChkLogin = sessionStorage.getItem("logStudentId") || localStorage.getItem("logStudentId");
    const jobSeekerIdChkLogin = sessionStorage.getItem("logProfileId") || localStorage.getItem("logProfileId");
    const userIdChkLogin = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");
    //const [pageURLArray, setPageURLArray] = useState(['/subscribetocareer','/companyDetails','/aboutus','/contactus','/jobSummary', '/jobsByCompany', '/ourlibrary', '/educationTraining', '/employerDirectory', '/companyRegister', '/studentRegistration', '/postResume', '/schoolDetails', '/schoolList', '/movingToTheArea', '/events', '/CompanyListByIndustry', '/industries', '/videoLibrary', '/marketSupport', '/locallifeCommunities', '/availableJobs', '/jobsummary', '/companyDetails']);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const loginRedirectVal = queryParams.get('loginRedirect');
    const logoutRedirectVal = queryParams.get('logoutRedirect');
    const loginResetVal = queryParams.get('loginReset');
    const afterLogoutRedirectVal = queryParams.get('alv');
    const staticData = require('../../constants/' + process.env.React_App_Static_Folder + '/static-data.json');
    const [pageURLArray] = useState([
        '/', '/Home',                         
        '/subscribetocareer', '/companyDetails', '/aboutus', '/contactus',
        '/jobSummary', '/jobsByCompany', '/ourlibrary', '/educationTraining',
        '/employerDirectory', '/companyRegister', '/studentRegistration',
        '/postResume', '/schoolDetails', '/schoolList', '/movingToTheArea',
        '/events', '/CompanyListByIndustry', '/industries', '/videoLibrary',
        '/marketSupport', '/locallifeCommunities', '/availableJobs', '/jobsummary',
        '/companyDetails','/applyJobProfile','/studentRegistrationPersonalInfo',
        '/studentRegistrationSchoolInfo', '/studentRegistrationFieldsofInterest',
        '/studentRegistrationCareerChoices','/privacyPolicy'
    ]);
    const keycloak = new Keycloak({
        url: process.env.React_App_KEYCLOAK_URL,
        realm: process.env.React_App_REALM,
        clientId: process.env.React_App_KEYCLOAK_CLIENT_ID
    })

    const logout = () => {
        sessionStorage.clear();
        sessionStorage.setItem("hideFlashPage", "1");

        localStorage.clear();
        localStorage.setItem("hideFlashPage", "1");

        keycloak.logout();
        keycloak.authenticated = false;
        keycloak.logout({ redirectUri: window.location.origin });

        //setTimeout(function () { alert("test");window.location.replace("/"); }, 1000);
    }

    function getCheckSess() {
        const requestObject =
        {

        }
        var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + accessTokenIn
                //'Authorization': accessTokenIn 
            },
            body: JSON.stringify(requestObject)
        };
        //var resp = services.loginVerify(requestOptions);
        var resp = services.loginVerifyService(requestOptions);
        const path = window.location.pathname;
        if (!resp && !pageURLArray.includes(path)) {
            logout();
        }
        

    }

    const logout2 = () => {
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem("hideFlashPage", "1");
        localStorage.setItem("hideFlashPage", "1");
        keycloak.authenticated = false;

        var url_to_redirect = window.location.href.split('?')[0];
        keycloak.logout({ "redirectUri": url_to_redirect });

        return;

    }

    const handleLogout = () => {
        sessionStorage.clear();
        localStorage.clear();
        keycloak.logout();
        keycloak.authenticated = false;
        window.location.replace("/Home");
    }
    function checkArray(needle, haystack) {
        var length = haystack.length;
        for (var i = 0; i < length; i++) {
            if (haystack[i] == needle) return true;
        }
        return false;
    }


    const handleLogin = () => {
        if (afterLogoutRedirectVal == "1") {
            return;
        }
        if (keycloak.authenticated) {
            if (keycloak.token != "") {
                setToken(keycloak.token);
            }
        } else {
            var url_to_redirect = window.location.href.split('?')[0];
            keycloak.login({ "redirectUri": url_to_redirect });
        }
    }

    function setToken(token) {
        var logObj = jwt(keycloak.token);
        var logObjStr = JSON.stringify(logObj);
        var lobObjVal = eval(logObj);
        if (lobObjVal.resource_access.snv3_app.roles) {
            var roleAr = lobObjVal.resource_access.snv3_app.roles;
        } else {
            var roleAr = [];
        }

        var logEmail = lobObjVal.email;
        if (logEmail) {
            logEmail = logEmail.trim();
        }


        const companyIdchck = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
        const studentIdchck = sessionStorage.getItem("logStudentId") || localStorage.getItem("logStudentId");
        const profileIdchck = sessionStorage.getItem("logProfileId") || localStorage.getItem("logProfileId");
        const userIdchck = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");



        if (userIdchck == null || userIdchck == "null") {
            //
            const requestObject =
            {
                "siteId": process.env.React_App_SITE_ID,
                "email": logEmail
            }


            var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");


            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestObject)
            };
            services.getUserInfoByEmail(requestOptions).then((res) => {
                console.log(JSON.stringify(res));

                if (checkArray("student", roleAr)) {
                    sessionStorage.setItem("logDisplayRole", "Student");
                    localStorage.setItem("logDisplayRole", "Student");
                } else if (checkArray("company", roleAr) || checkArray("companyuser", roleAr) || checkArray("companyadmin", roleAr)) {
                    sessionStorage.setItem("logDisplayRole", "Company");
                    localStorage.setItem("logDisplayRole", "Company");
                } else if (checkArray("jobseeker", roleAr)) {
                    sessionStorage.setItem("logDisplayRole", "Job Seeker");
                    localStorage.setItem("logDisplayRole", "Job Seeker");
                } else if (checkArray("schoolsuper", roleAr) || roleAr == "schoolsuper") {
                    sessionStorage.setItem("logDisplayRole", "School Super Admin");
                    localStorage.setItem("logDisplayRole", "School Super Admin");
                } else if (checkArray("schooladmin", roleAr) || roleAr == "schooladmin") {
                    sessionStorage.setItem("logDisplayRole", "School Admin");
                    localStorage.setItem("logDisplayRole", "School Admin");
                }
                sessionStorage.setItem("logKCDisplayName", lobObjVal.name);
                localStorage.setItem("logKCDisplayName", lobObjVal.name);

                if (res) {
                    var temp = res;
                    if (res) {

                        if (res.name == "network error") {
                            sessionStorage.setItem("logEmail", lobObjVal.email);
                            localStorage.setItem("logEmail", lobObjVal.email);
                            navigate('/thankyou?r=11');
                            return;
                        }

                        if (!res.userId) {
                            sessionStorage.setItem("logEmail", lobObjVal.email);
                            localStorage.setItem("logEmail", lobObjVal.email);
                            navigate('/thankyou?r=11');
                            return;
                        }

                        if (res.status == "inactive") {
                            navigate('/thankyou?r=10');
                            sessionStorage.clear();
                            localStorage.clear();
                            keycloak.logout();
                            keycloak.authenticated = false;
                            return;
                        }

                        if (res.status == "pending" || res.status == "Pending") {
                            navigate('/thankyou?r=9');
                            sessionStorage.clear();
                            localStorage.clear();
                            keycloak.logout();
                            keycloak.authenticated = false;
                            return;
                        }

                        if (checkArray("siteadmin", roleAr) || roleAr == "siteadmin") {
                            keycloak.logout();
                            keycloak.authenticated = false;
                            window.location.href = process.env.React_App_SITE_ADMIN_URL;
                            return;
                        }

                        console.log(res);

                        sessionStorage.setItem("accToken", token);
                        localStorage.setItem("accToken", token);
                        var logObjStr = JSON.stringify(logObj);
                        sessionStorage.setItem("logObj", logObjStr);
                        sessionStorage.setItem("roleAr", roleAr);
                        sessionStorage.setItem("logEmail", lobObjVal.email);
                        sessionStorage.setItem("appEmail", res.email);
                        sessionStorage.setItem("hideFlashPage", "1");
                        sessionStorage.setItem("logCompanyId", res.companyId);
                        sessionStorage.setItem("logStudentId", res.studentId);
                        sessionStorage.setItem("logProfileId", res.profileId);
                        sessionStorage.setItem("logUserId", res.userId);

                        localStorage.setItem("logObj", logObjStr);
                        localStorage.setItem("roleAr", roleAr);
                        localStorage.setItem("logEmail", lobObjVal.email);
                        localStorage.setItem("appEmail", res.email);
                        localStorage.setItem("hideFlashPage", "1");
                        localStorage.setItem("logCompanyId", res.companyId);
                        localStorage.setItem("logStudentId", res.studentId);
                        localStorage.setItem("logProfileId", res.profileId);
                        localStorage.setItem("logUserId", res.userId);

                        console.log('****** 219 ********' + res.companyId);


                        sessionStorage.setItem("displayName", res.firstName + " " + res.lastName);
                        sessionStorage.setItem("companyPopupState", "1");

                        localStorage.setItem("displayName", res.firstName + " " + res.lastName);
                        localStorage.setItem("companyPopupState", "1");

                        // return false;
                        if (checkArray("student", roleAr)) {
                            navigate('/studentDashboard');
                        } else if (checkArray("company", roleAr) || checkArray("companyuser", roleAr) || checkArray("companyadmin", roleAr)) {

                            window.location.replace("/companyJobs");
                        } else if (checkArray("jobseeker", roleAr)) {
                            navigate('/profileDashboard');
                        } else if (checkArray("schoolsuper", roleAr) || roleAr == "schoolsuper") {
                            navigate('/studentList');
                        } else if (checkArray("schooladmin", roleAr) || roleAr == "schooladmin") {
                            navigate('/studentListBySchool');
                        }

                    } else {
                        keycloak.logout();
                    }
                }

            });
            //
        }
    }

    const handleOnEvent2 = async (event, error) => {
        console.log("############ event-->" + event);
    }
    const handleOnEvent = async (event, error) => {

        if (event === 'onReady') {
            if (keycloak.authenticated) {
                if (keycloak.token != "") {
                    setToken(keycloak.token);

                }
            }
        }
        if (event === 'onAuthSuccess') {

            if (keycloak.authenticated) {
                if (keycloak.token != "") {
                    setToken(keycloak.token);
                }

            } else {
                //window.location.href="/login";
            }
        }
    }

    useEffect(() => {
       
        if (loginResetVal == "1") {
            handleLogout();
        }

        if (window.location.pathname == "/studentDashboard") {
            // $(".login-desktop").hide();
            $(".user-log-dropd").hide();
        }

        try {
            if (loginRedirectVal == "1" && typeof (loginRedirectVal) == "string") {
                console.log("redirecting to login");
                handleLogin();
            }
        } catch (ex) {
            console.log("Exception--" + ex);
        }

        try {
            if (logoutRedirectVal == "1" && typeof (logoutRedirectVal) == "string") {
                console.log("redirecting to login");
                logout2();
            }
        } catch (ex) {
            console.log("Exception--" + ex);
        }
        //setInterval(getCheckSess, 1800000);
        setInterval(getCheckSess, 900000);
        setTimeout(() => {
            var accessTokenIn=sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
            const path = window.location.pathname;
           
            if (!keycloak.authenticated && accessTokenIn) {
                logout();
            } else if (!keycloak.authenticated) {
                
                if (!pageURLArray.includes(path)) {
                    logout();
                }
            }
        }, 5000);
    }, []);




    return (
        <>
            <ReactKeycloakProvider authClient={keycloak} onEvent={(event, error) => handleOnEvent(event, error)}>

                <header class="main-header desktop-menu">
                    <nav class="top-nav-bk w-100">
                        <div class="container d-flex flex-wrap justify-content-between">
                            <ul class="nav align-items-center">
                                <li class="nav-item"><a href="/aboutus" class="nav-link link-light px-2 active" aria-current="page">About Us</a>
                                </li>
                                <li class="nav-item"><a href="/contactus" class="nav-link link-light px-2">Contact Us</a>
                                </li>
                            </ul>
                            <div class="county-top">
                                <div class="d-flex ct-next">
                                    <div><label for="">Proudly Serving:</label> <span>Auglaize</span> | <span>Darke</span> | <span>Mercer</span> | <span>Shelby</span> <label for="">Counties</label> <img src="/images/oh.png" alt="" /> </div>
                                </div>
                            </div>
                            <ul class="nav align-items-center">

                                <li class="nav-item"><a href="/faq" class="nav-link link-light px-2">FAQ</a>
                                </li>

                                {(() => {
                                    if (window.location.pathname == "/studentDashboard") {
                                        return (
                                            <li class="nav-item dropdown user-log-dropd">
                                                <a class="nav-link dropdown-toggle" href="#" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Student
                                                </a>
                                                <ul class="dropdown-menu" aria-labelledby="navbarScrollingDropdown">

                                                    <li><a onClick={() => logout()} class="dropdown-item" >SIGN OUT</a></li>
                                                </ul>
                                            </li>
                                        )
                                    }
                                })()}

                                {(() => {
                                    if (window.location.pathname != "/companyDashboard") {

                                        if (userIdChkLogin != null && userIdChkLogin != "null") {
                                            return (<><li class="nav-item login-desktop"><a onClick={() => logout()} class="nav-link link-light px-2 logoutBtnCls">SIGN OUT</a></li></>);
                                        } else {
                                            return (<li class="nav-item login-desktop"><a onClick={handleLogin} class="nav-link link-light px-2">SIGN IN</a></li>)
                                        }

                                    } else {
                                        return (
                                            <>
                                                <li class="nav-item login-desktop"><a href="#" class="nav-link link-light px-2">Post a Job</a> </li>
                                                <li class="nav-item dropdown user-log-dropd">
                                                    <a class="nav-link dropdown-toggle" href="#" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        Jhon
                                                    </a>
                                                    <ul class="dropdown-menu" aria-labelledby="navbarScrollingDropdown">
                                                        <li><a class="dropdown-item" href="/companyDashboard">Dashboard</a></li>
                                                        <li><a class="dropdown-item" href="/login">SIGN OUT</a></li>
                                                    </ul>
                                                </li></>
                                        )
                                    }
                                })()}

                            </ul>
                        </div>
                    </nav>
                    <div class="main-menu">
                        <nav class="navbar navbar-expand-lg navbar-light d-none d-lg-block">
                            <div class="container">
                                <a class="navbar-brand" href="/home">

                                    <img src={staticData.company_logo} alt="" />
                                </a>
                                <div class="collapse navbar-collapse " id="navbarNav">
                                    <ul class="navbar-nav ms-auto">
                                        {(() => {
                                            if (window.location.pathname == "/companyDashboard" || window.location.pathname == "/studentDashboard") {
                                                return (
                                                    <li class="nav-item"> <a class="nav-link active" aria-current="page" href="/availableJobs">
                                                        Available Jobs</a>
                                                    </li>
                                                )
                                            } else {
                                                return (
                                                    <li class="nav-item"> <a class="nav-link active" aria-current="page" href="/availableJobs">Available Jobs</a>
                                                    </li>
                                                )
                                            }
                                        })()}

                                        {/* <li class="nav-item"> <a class="nav-link active" aria-current="page" href="/industries">Industries</a></li> */}

                                        <li class="nav-item dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Job Seekers
                                            </a>
                                            <ul class="dropdown-menu animate__bounceIn" aria-labelledby="navbarDropdown">
                                                {(() => {

                                                    if (jobSeekerIdChkLogin != null && jobSeekerIdChkLogin != "null") {
                                                        return (<><li><a class="dropdown-item" href="/profileDashboard">Job Seeker Dashboard</a></li></>);
                                                    } else {
                                                        return (<><li><a class="dropdown-item" href="/postResume">Job Seeker Registration</a></li></>);
                                                    }

                                                })()}
                                                <li><a class="dropdown-item" href="/employerDirectory">Employer Directory</a></li>
                                                <li><a class="dropdown-item" href="/industries">Employers by Industry</a></li>
                                            </ul>
                                        </li>


                                        <li class="nav-item dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Students
                                            </a>
                                            <ul class="dropdown-menu animate__bounceIn" aria-labelledby="navbarDropdown">


                                                {(() => {

                                                    if (studentIdChkLogin != null && studentIdChkLogin != "null") {
                                                        return (<><li><a class="dropdown-item" href="/studentDashboard">Student Dashboard</a></li></>);
                                                    } else {
                                                        return (<><li><a class="dropdown-item" href="/studentRegistrationPersonalInfo">Student Registration</a></li></>);
                                                    }

                                                })()}

                                                <li><a class="dropdown-item" href="/educationTraining">Colleges & Universities</a></li>
                                                <li><a class="dropdown-item" href="/ourlibrary">Local Libraries</a></li>
                                                <li><a class="dropdown-item" target="_blank" href=" http://education.ohio.gov/Topics/Career-Tech/Career-Connections/Career-Pathways">Career Pathways</a></li>

                                            </ul>
                                        </li>

                                        <li class="nav-item dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Employers
                                            </a>
                                            <ul class="dropdown-menu animate__bounceIn" aria-labelledby="navbarDropdown">
                                                {(() => {

                                                    if (companyIdChkLogin != null && companyIdChkLogin != "null") {
                                                        return (<><li><a class="dropdown-item" href="/companyJobs">Employer Dashboard</a></li>
                                                            <li><a class="dropdown-item" href="/postJob">Post a Job</a></li>
                                                            <li><a class="dropdown-item" href="/personalProfiles">View Resumes</a></li></>);
                                                    } else {
                                                        return (<><li><a class="dropdown-item" href="/companyRegister">Employer Registration</a></li></>);
                                                    }

                                                })()}

                                                {/* <li><a class="dropdown-item" href="/employerDirectory">Directory</a></li> */}
                                            </ul>
                                        </li>

                                        <li class="nav-item dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Local Life
                                            </a>
                                            <ul class="dropdown-menu animate__bounceIn" aria-labelledby="navbarDropdown">
                                                <li><a class="dropdown-item" href="/locallifeCommunities">Our Community</a></li>
                                                <li><a class="dropdown-item" href="/schoolList">Local Schools</a></li>
                                                <li><a class="dropdown-item" href="/movingToTheArea">Moving to the Area</a></li>
                                            </ul>
                                        </li>


                                        <li class="nav-item dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Resources
                                            </a>
                                            <ul class="dropdown-menu animate__bounceIn" aria-labelledby="navbarDropdown">
                                                {(() => {
                                                    if (window.location.pathname != "/studentDashboard") {
                                                        return (<>

                                                            <li><a class="dropdown-item" href="/videoLibrary">Video Library</a></li>
                                                            <li><a class="dropdown-item" href="/events">Events Calendar</a></li>
                                                            <li><a class="dropdown-item" href="/marketSupport">Brand Media</a></li>

                                                        </>)
                                                    }
                                                })()}


                                                {(() => {
                                                    if (window.location.pathname == "/companyDashboard" || window.location.pathname == "/studentDashboard") {
                                                        return (<>

                                                            <li><a class="dropdown-item" href="/videoLibrary">video Library</a></li>
                                                            <li><a class="dropdown-item" href="/events">Events Calendar</a></li>
                                                            <li><a class="dropdown-item" href="/marketSupport">Brand Media</a></li>

                                                        </>)
                                                    }
                                                })()}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </header>
                <header class="main-header mobile-menu">
                    <div class="navbar navbar-expand-lg ">
                        <div class="container">

                            <a class="navbar-brand" href="/home"> <img src={staticData.company_logo} alt="" /></a>
                            <div class="icons ml-auto">
                                <ul>
                                    <div class="menu-icon"></div>
                                    <div class="menu-icon"></div>
                                    <div class="menu-icon"></div>
                                </ul>
                            </div>

                            <div id="mySidenav" class="sidenav d-lg-none">
                                <a class="navbar-brand" href="#"><img src="images/logo-white.svg" alt="" /></a>

                                <div class="menu ml-auto" id="menu">
                                    <ul class="list-unstyled mob-nav ps-0">
                                        <li class="mb-1"> <a href="/availableJobs">Available Jobs</a> </li>

                                        {/*<li class="mb-1"> <a href="/industries">Industries</a> </li> */}



                                        <li class="mb-1 btn-toggle">
                                            <a href="#" class=" collapsed" data-bs-toggle="collapse" data-bs-target="#js-collapse" aria-expanded="false">
                                                Job Seekers
                                            </a>
                                            <div class="collapse" id="js-collapse">
                                                <ul class="btn-toggle-nav list-unstyled ">

                                                    {(() => {

                                                        if (jobSeekerIdChkLogin != null && jobSeekerIdChkLogin != "null") {
                                                            return (<><li class="mob-sub"><a href="/profileDashboard">Job Seeker Dashboard</a></li>
                                                                <li class="mob-sub"><a href="/postJob">Post a Job</a></li></>);
                                                        } else {
                                                            return (<><li class="mob-sub"><a href="/postResume">Job Seeker Registration</a></li></>);
                                                        }

                                                    })()}
                                                    <li class="mob-sub"><a href="/employerDirectory">Employer Directory</a></li>
                                                    <li class="mob-sub"><a href="/industries">Employers by Industry</a></li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="mb-1 btn-toggle">
                                            <a href="#" class=" collapsed" data-bs-toggle="collapse" data-bs-target="#std-collapse" aria-expanded="false">
                                                Students
                                            </a>
                                            <div class="collapse" id="std-collapse">
                                                <ul class="btn-toggle-nav list-unstyled ">

                                                    {(() => {

                                                        if (studentIdChkLogin != null && studentIdChkLogin != "null") {
                                                            return (<><li class="mob-sub"><a href="/studentDashboard">Student Dashboard</a></li></>);
                                                        } else {
                                                            return (<><li class="mob-sub"><a href="/studentRegistrationPersonalInfo">Student Registration</a></li></>);
                                                        }

                                                    })()}

                                                    <li class="mob-sub"><a href="/educationTraining">Colleges & Universities</a></li>
                                                    <li class="mob-sub"><a href="/ourlibrary">Local Libraries</a></li>
                                                    <li class="mob-sub"><a href="http://education.ohio.gov/Topics/Career-Tech/Career-Connections/Career-Pathways" target="_blank">Career Pathways</a></li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="mb-1 btn-toggle">
                                            <a href="/employerDirectory" class=" collapsed" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
                                                Employers
                                            </a>
                                            <div class="collapse" id="dashboard-collapse">
                                                <ul class="btn-toggle-nav list-unstyled ">

                                                    {(() => {

                                                        if (companyIdChkLogin != null && companyIdChkLogin != "null") {
                                                            return (<><li class="mob-sub"><a href="/companyJobs">Employer Dashboard</a></li>
                                                                <li class="mob-sub"><a href="/postJob">Post a Job</a></li>
                                                                <li class="mob-sub"><a href="/personalProfiles">View Resumes</a></li></>);
                                                        } else {
                                                            return (<><li class="mob-sub"><a href="/companyRegister">Employer Registration</a></li></>);
                                                        }

                                                    })()}

                                                    {/* <li class="mob-sub"><a href="/employerDirectory"> Directory</a></li> */}

                                                </ul>
                                            </div>
                                        </li>


                                        <li class="mb-1 btn-toggle">
                                            <a href="#" class=" collapsed" data-bs-toggle="collapse" data-bs-target="#locallife" aria-expanded="false">
                                                Local Life
                                            </a>
                                            <div class="collapse" id="locallife">
                                                <ul class="btn-toggle-nav list-unstyled ">
                                                    <li class="mob-sub"><a href="/locallifeCommunities" class="link-dark rounded">Our Community</a></li>
                                                    <li class="mob-sub"><a href="/schoolList" class="link-dark rounded">Local Schools</a></li>
                                                    <li class="mob-sub"><a class="link-dark rounded" href="/movingToTheArea">Moving to the Area</a></li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="mb-1 btn-toggle">
                                            <a href="#" class=" collapsed" data-bs-toggle="collapse" data-bs-target="#resources" aria-expanded="false">
                                                Resources
                                            </a>
                                            <div class="collapse" id="resources">
                                                <ul class="btn-toggle-nav list-unstyled">

                                                    <li class="mob-sub"><a href="/videoLibrary" class="link-dark rounded">Video Library</a></li>
                                                    <li class="mob-sub"><a href="/events" class="link-dark rounded">Events Calendar</a></li>
                                                    <li class="mob-sub"><a href="/marketSupport" class="link-dark rounded">Brand Media</a></li>

                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="second-nav">
                                        <li><a href="/aboutus">About Us</a></li>
                                        <li><a href="/contactus">Contact Us</a></li>
                                        <li><a href="/faqs">Faq</a></li>

                                        {(() => {
                                            if (userIdChkLogin != null && userIdChkLogin != "null") {
                                                return (<><li><a onClick={logout} class="mobile-login">SIGN OUT</a></li></>);
                                            } else {
                                                return (<li><li><a onClick={handleLogin} class="mobile-login">SIGN IN</a></li></li>)
                                            }

                                        })()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

            </ReactKeycloakProvider>
        </>

    );
};

export default HeaderHTO;